/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSignalG = createReactComponent("signal-g", "IconSignalG", [
  [
    "path",
    { d: "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", key: "svg-0" }
  ]
]);

export { IconSignalG as default };
//# sourceMappingURL=IconSignalG.js.map
